import { getSaleInfo, type SaleInfoInput } from "@/lib/saleHelpers";

interface Props extends SaleInfoInput {
  /** Where the ribbon sits on its parent. Parent must be `relative`. */
  position?: "top-left" | "top-right";
  className?: string;
}

/**
 * Diagonal "SALE -N%" corner ribbon for product thumbnails.
 * Renders nothing when the product isn't on sale.
 */
export function SaleRibbon({ position = "top-left", className = "", ...info }: Props) {
  const sale = getSaleInfo(info);
  if (!sale.isOnSale) return null;

  const side = position === "top-left" ? "left-0" : "right-0";
  const rotate = position === "top-left" ? "-rotate-45 -translate-x-1/3" : "rotate-45 translate-x-1/3";

  return (
    <div className={`pointer-events-none absolute top-0 ${side} z-10 overflow-hidden ${className}`} style={{ width: 96, height: 96 }}>
      <div
        className={`absolute top-4 ${side === "left-0" ? "left-[-28px]" : "right-[-28px]"} ${rotate} text-white text-[11px] font-extrabold uppercase tracking-wider text-center shadow-md`}
        style={{ backgroundColor: "#dc2626", width: 140, padding: "4px 0", letterSpacing: "0.08em" }}
      >
        {sale.percentOff ? `Sale -${sale.percentOff}%` : "Sale"}
      </div>
    </div>
  );
}

export default SaleRibbon;
